import React from 'react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = 'QUIERO ENTRAR A LA PREVENTA',
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (href) {
      window.location.href = href;
    } else if (onClick) {
      onClick();
    } else {
      const target = document.getElementById('compra');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg md:text-xl font-extrabold text-white uppercase transition-all duration-200 bg-green-600 rounded-lg hover:bg-green-500 hover:-translate-y-1 shadow-[0_8px_20px_-4px_rgba(22,163,74,0.6)] hover:shadow-[0_12px_25px_-4px_rgba(22,163,74,0.8)] ${className}`} data-id="element-255">
      <span className="relative flex items-center gap-2" data-id="element-256">
        {text}
        <svg className="w-6 h-6 transition-transform duration-200 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-257">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 5l7 7-7 7M5 5l7 7-7 7" data-id="element-258" />
        </svg>
      </span>
    </button>;
}